import { createContext, useCallback, useState } from 'react'

import { ValidCouponDTO } from '~/modules/sales/types'

import { CartArea } from './CartArea'
import { DiscountInput } from './DiscountInput'

type DiscountContextData = {
  coupon?: ValidCouponDTO
  handleSetCoupon(c?: ValidCouponDTO): void
}

export const discountFormContext = createContext<DiscountContextData>(
  {} as DiscountContextData,
)

export const ReceiptAndDiscount: React.FC = () => {
  const [coupon, setCoupon] = useState<ValidCouponDTO>()

  const handleSetCoupon = useCallback((c: ValidCouponDTO) => {
    setCoupon(c)
  }, [])

  return (
    <discountFormContext.Provider value={{ coupon, handleSetCoupon }}>
      <CartArea />
      <DiscountInput />
    </discountFormContext.Provider>
  )
}
